import { AXDialogService } from '@acorex/components/dialog';
import { AXToastService } from '@acorex/components/toast';
import { AXTranslationService } from '@acorex/core/translation';

// import { Location } from '@angular/common';
import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { PlatformService, StorageService } from '@travel/shared/services';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  // const _location = inject(Location);
  const toast = inject(AXToastService);
  const _platformService = inject(PlatformService);
  const _storageService = inject(StorageService);
  const _dialogService = inject(AXDialogService);
  const translateService = inject(AXTranslationService);
  request = request.clone({
    headers: request.headers.set('Accept-Language', _platformService.siteLanguage() || 'fa'),
  });

  const token = _storageService.get('USER_PROFILE').token;
  if (token) {
    if (!request.url.match('https://map.ir/static')) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`),
      });
    }
  }

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      let messages = '';
      let error!: any[];
      switch (err.status) {
        case 500:
          if (err?.error?.messages?.length) {
            messages = `خطا در برقراری ارتباط کد خطا ${err.error.messages[0].code}`;
          } 
          else {
            messages = 'خطا در برقراری ارتباط';
          }
          toast.show({
            color: 'danger',
            // content: err.url as any,
            title: messages,
            timeOut: 4000,
            timeOutProgress: true,
            // icon: 'fa-regular fa-triangle-exclamation',
          });
          break;
        case 400:
          if (err.error?.messages) {
            error = err.error?.messages;
            error.forEach((el: any, index: number) => {
              messages += error.length > 1 ? index + 1 + '- ' + el.description : '' + el.description;
            });
            toast.show({
              color: 'danger',
              content: messages,
              title: translateService.translateSync('common.attention'),
              timeOut: 4000,
              timeOutProgress: true,
            });
            // _dialogService.alert(translateService.translateSync('common.attention'), messages, 'danger');
          }
          break;
        case 401:
          if (!err.error?.error_description) {
            // _dialogService.alert(translateService.translateSync('common.attention'), 'خطا در اعتبار سنجی، کلید رمزگذاری شده نامعتبر ', 'danger');
            _storageService.clear();
          }
          break;
        case 403:
          // _dialogService.alert(translateService.translateSync('common.attention'), 'شما دسترسی به این قسمت ندارید.', 'danger');
          // _location.back();
          break;
        case 409:
          
          if (err.error?.messages) {
            error = err.error?.messages;
            error.forEach((el: any, index: number) => {
              messages += error.length > 1 ? index + 1 + '- ' + el.description : '' + el.description;
            });
            toast.show({
              color: 'danger',
              content: messages,
              title: translateService.translateSync('common.attention'),
              timeOut: 4000,
              timeOutProgress: true,
            });
            // _dialogService.alert(translateService.translateSync('common.attention'), messages, 'danger');
          }
          break;
        case 404:
          if (!err.error?.error_description) {
            // this._dialogService.alert(this.translateService.translateSync('common.attention'), 'خطا در اعتبار سنجی، کلید رمزگذاری شده نامعتبر ', 'danger');
            toast.show({
              color: 'danger',
              content: 'آدرس مورد نظر وجود ندارد ',
              title: translateService.translateSync('common.attention'),
              timeOut: 4000,
              timeOutProgress: true,
            });
          }
          break;
        default:
          // toast.show({
          //   color: 'danger',
          //   content: err.error?.reason,
          //   timeOut: 4000,
          //   icon: 'fa-regular fa-triangle-exclamation',
          // });
          return throwError(() => err) || null;
        // break;
      }
      return throwError(() => err);
    })
  );
};
